module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_balloon02-6ee15f2409d3908c7aae24fa2fc7ef46.png";